import { render, staticRenderFns } from "./accurate-teacher.vue?vue&type=template&id=9175b35e&scoped=true"
import script from "./accurate-teacher.vue?vue&type=script&lang=js"
export * from "./accurate-teacher.vue?vue&type=script&lang=js"
import style0 from "./accurate-teacher.vue?vue&type=style&index=0&id=9175b35e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9175b35e",
  null
  
)

export default component.exports